// @flow
import LogeList from 'components/entreprise/loge/LogeList';
import { connect } from 'react-redux';
import { fetchLogeList } from 'actions/logeActions';
import { fetchPageDetailCustom } from 'actions/pageActions';
import { fetchArticles } from 'actions/articlesActions';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/entreprise/loge/LogeList';

export default connect(
  (state: StateType): StateProps => ({
    title: state.filterOptionsState.typeLogeTitle,
    meta_title: state.filterOptionsState.typeLogeTitle,
    loges: state.logeListState.loges,
    description: state.filterOptionsState.typeLogeDescription,
    meta_description: state.filterOptionsState.typeLogeDescription,
    status: state.logeListState.status,
    slug_article: state.pageDetailState.label,
    articles: state.articlesState.articles,
    breadcrumb_offres_entreprise: state.settingsState.breadcrumb_offres_entreprise,
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchPageDetail: (slug: string) => dispatch(fetchPageDetailCustom(slug)),
    fetchArticles: (category: any) => dispatch(fetchArticles(category)),
    fetchLogeList: (match?: string) => dispatch(fetchLogeList(match)),
  })
)(LogeList);
